import { CallDirection, ConferenceState, SAPContact } from '../../types';

export const initialConferenceState: ConferenceState = {
  status: 'idle',
  consultContactId: null,
  consultTarget: null,
};

export interface LastCallInfo {
  contactId: string;
  skillId: string;
  skillName?: string;
  requireDisposition?: boolean;
  callTraceId?: string;
  direction?: CallDirection | null;
  callerName?: string | null;
  callerNumber?: string | null;
  dnis?: string | null;
  startTime?: Date | null;
  endedAt?: Date | null;
}

export interface OutboundCallInfo {
  phone: string;
  sapContactId?: string;
  startedAt: string;
  referenceId: string;
}

export interface ManualSearchState {
  contacts: SAPContact[];
  isLoading: boolean;
  error?: string;
}
